module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('span', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Section4"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "calibre6",
    attrs: {
      "id": "calibre_toc_3"
    }
  }, [_vm._v("Chapter Two")]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Bev woke up on Thursday morning feeling like a bug run over by a roller skate. She reeled from the bed to the bathroom, looked in the mirror, and discovered she looked even worse. Another miserable period.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("She was bent double with cramps, her legs were trembling, her head felt like a cracked melon, she was bleeding so heavily that she was sure she was close to hemorrhaging, and she had had enough. She called her gynecologist's office and talked the receptionist into an appointment for that very afternoon to have her IUD removed.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Carl Panstiel was no stranger. She had known him for years. He went to her mother's church, had given her her premarital exam and birth control pills, checked her every time she came home to visit her parents and had cried real tears at Bob's memorial service.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("She didn't see him just because he was the only ob-gyn in the area she knew, but because she liked him. Not romantic like, or even best-friend like—because he had a wife and children whom she also liked—but because he was modern and liberal in his views, clever and friendly and warm in his attitude, and because he had a real thing for her. One could almost say they had a relationship, but one had to be very careful about saying things like that.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("He had a way of getting her to open up—and just now she really needed to talk. He could make her laugh. He would be sympathetic and understanding and let her pretend that that was the last thing she needed. Beverly, the strong.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("When her name was called she was led into the doctor's office instead of the examining room, which was what she expected. Carl walked into the room with his head down and nose in the records that had been sent by her physician in Dallas, which was also what she expected. Her file was fairly good reading. Then he looked up, smiled and said hello, and she felt like a regular psychic.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“You want it out?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“It's been giving me a lot of trouble. Heavy periods. It's uncomfortable.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“How long have you been wearing this model?” He obviously couldn't read. Real dumb for a doctor.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Since Chuck was born. Five years plus.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Heavy periods are common to the IUD. It doesn't necessarily mean anything is wrong. I can check it and make sure there's no problem or I can take it out and put in another type. There's a fairly new one I've been using that's more comfortable to wear.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Yank it. I don't need it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“You want to take pills instead?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“They don't agree with me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“The diaphragm isn't nearly as safe, even when used carefully. There's always the chance of pregnancy... a chance you wouldn't want to take.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I don't want that either. I'm safe with nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“When was the last time you had intercourse?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("So he was going to make her say it. Well, okay, Carl, you asked for it. “Six months ago or so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I believe you would be much safer with the IUD or pills.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Carl Panstiel, the poor deaf doctor, she thought, but she said, “I'm safe with nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“You've always been a good planner, Bev. Don't mess up this time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I messed up once, Carl. Remember Chuck?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("He laughed, more at the sound of her finally using his first name than the thought of the accidental baby. “Are you sure, Bev? Want to tell me about why you're really here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“What's to tell? It's on the chart.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Yes, it's here. 'No physiological reason for orgasmic impairment.' Is that what this visit is about, Bev?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“No.” Guy had tactfully never mentioned the stretch marks, though she was sure he had noticed. He had rather crudely mentioned the other thing that was also slightly stretched and suggested that might be the problem. She had begun to think he was right. He looked like he should be a champ, he thought he was a champ. He was a dud. “It's just this IUD. I don't need any more headaches.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“And the 'impairment'?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Wrong time, wrong place.” She shrugged. Wrong Guy.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Bev, are you doing okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Hell, no, I'm not doing okay. But I'm living, even if I'm not living it up. Unless you have a pill to kill that old desire, there's nothing I can do, nothing. I'm either going to have to turn into a whore, or do without.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Are you trying to shock me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Here?” Tears. Damn the tears. “I know better than that, Carl. You probably see more smut in this nice little office than I could ever dream up. I'm still not sleeping very well. Maybe a tranquilizer or something?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("He frowned. Bev knew from way back he wasn't in favor of a pill for every problem. He pushed only one kind of pill.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Okay, Bev, let's do this. I'll give you two prescriptions: one for foam and one for pills. You know how to take them. If you use the foam once, start the pills. How do they affect you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I get crabby,” she said with a sniff.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("He laughed. “Do you get crabby when you're pregnant?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I get suicidal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Carl laughed again. He was crazy about Beverly. He always had been. She was pretty and bright. She had girl-next-door looks that contrasted delightfully with an honest personality and a wise-cracking mouth. There had been an obvious sparkle and verve about her since the first day he met her, the kind of effervescence that made those around her feel happy. She bubbled a little less now, but still there was that wit, that light and sensitive mood about her that made him chuckle. It pained him to think she was struggling to keep her chin up. She was entitled to more.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Okay, Bev, just fill the prescriptions and have the pills on hand. If you want something else, just give me a call. Go get ready and I'll call a nurse.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Wanna get right to the good stuff, huh, Carl?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I knew you hadn't changed. Nothing can change you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Well, go ahead, admit it, Carl. You love looking at women's bottoms.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I admit it already. I love it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Yeah, but you really love it. Really.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Yeah,” he said, and smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Beverly went into the adjoining examination room to strip. This was a familiar setting. She remembered all the examinations Carl had given her through the years. She smiled wistfully, recalling that first exam she'd had after she'd lost her virginity. She'd been so afraid he would tell her mother. How young she'd been. Carl didn't act like a wise guy back then. He was gentle and kind and shy with her, easing her through the procedure so she wouldn't be embarrassed.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("So how could you go to a good friend, a man you liked so much, to have an IUD out when you were gushing? Because Carl might just as well be looking at her nose. He was in the bottom business. What a life. And he was a good ob-gyn, one of the best.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("She checked the mirror to see if her eyes were all red from that little bit of crying. She liked her new haircut. Guy had said, “I love your hair. I love long hair on a woman. It's sexy.” That's why she arranged to have it cut in one of those too-short-to-even-blow-dry styles as soon as she was back in Ohio. Because it would have made Guy mad and she didn't want to have sexy hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“This is going to cause some cramps,” Carl was saying. “It's a little more difficult coming out than going in right after a baby.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Is it... well, having the boys so close together and all... it's a little... large, isn't it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Tighten your vagina around my fingers. More. Seems perfectly functional. Exercise will improve muscle control. Are you working, Bev?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Just part-time modeling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Modeling?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Don't even ask, Carl. It was an accident.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Modeling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I am not a model; I'm doing some modeling. Middle-aged modeling,” she muttered. “They get fourteen-year-olds to model for the twenty-five-year-olds, and thirty-five-year-olds to model for the fifty-year-olds.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“You're not thirty-five.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Almost,” she said wearily.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“You are having some heavy bleeding. Nothing serious, but if you have a problem with this later, give me a call. Don't overdo today, okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Okay.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“You have some time on your hands?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Afternoons. Both the boys are in school now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I could use a favor—”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Carl, are you going to try to fill up my empty days?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Beverly...”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Need a volunteer in your office?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“It's the Christmas pageant at the church in Maple Hills. We do it every year. I have the five-year-olds and Sharon has the six-year-olds. She wants me to get an assistant so she doesn't get stuck with both classes. If I have a baby, you know? Want to help?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Oh, Carl, the church won't help. I've tried that. “I'm kind of busy. There must be someone over there—”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Now, Beverly...”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“How much time would it take?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Just a couple of meetings and going with your kids to Sunday school for four weeks. They'll rehearse in Sunday school, have one dress rehearsal, and then do the pageant.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I guess I could handle that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“If you're too busy—”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Better take it while I'm offering, Carl. I'm not going to beg you to let me help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“The first meeting is the Thursday after Thanksgiving in the rec room at seven-thirty "), _c('span', {
    staticClass: "calibre8"
  }, [_vm._v("p.m")]), _vm._v(". Don't get up, Bev. Just lie there and let the bleeding slow down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Okay.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“See you in a couple of weeks?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Sure.” But I don't have to like it.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("This was so like Carl. He was probably in this with her mother. Drag her to church, let the church pull her through. Beverly had had it with church. It was not the answer. Not for her. For the boys maybe, but certainly not for her.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Beverly had to be thankful for one thing: Holidays were easier when there was family around. Thanksgiving was so hectic that she hardly thought about quiet holidays in the past with Bob and the kids. Terry, with her shadow, Steve, Barbara and her husband and baby, Stephanie and Mike and their kids, and John all gathered at their parents' house.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Just a few years separated Bev and John, and they had been close since childhood, even skating through the teen years as good friends. And they would be close still if John weren't so busy interning at County General Hospital. He had almost no free time for Bev... or for anyone else.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("It was after the enormous meal that Bev's stubbornness had borne her straight into a commitment that she and the boys would certainly regret. Her mother was discussing plans for Christmas and Bev settled back in her chair and lit a cigarette. As if it were a cue, her mother launched into an antismoking lecture. And, even though Bev couldn't enjoy her cigarette then, she wouldn't put it out. She had learned how to pretend to tune her mother out, hadn't she?")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("So, entrenching herself in stubbornness, she'd told her family that she and the boys would celebrate on Christmas Eve with them, but stay home on Christmas Day. Sorry, but that's the way it was going to be. Yes, she knew it was a family day. But remember, however small, she and her sons were a family. They would learn to get along without their man; they would open presents on Christmas morning without Daddy. They would be strong.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("It was a lot of happy horseshit, she knew. Christmas was bound to be miserable, but what could she do? Run home every time something bothered her or reminded her of her dead husband, of her fatherless boys? Every time she got lonesome? The kids needn't be constantly reminded that their lifestyle was slightly different from others, and this was a way to show them that it could be fine, even if Daddy was missing. Bev was determined to face the fact—and the fact was that the noisier it was on Christmas Day, the less lonely it would be. Still, they would stay home.")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("On Thursday Bev went to the rec room in the church about fifteen minutes before the meeting was to start so that Carl and Sharon could take her by the hand and lead her around to meet all the other goodie-goodie people working on the Christmas pageant. She hated him for asking her to do this. What she didn't need now was a bunch of straight-laced devout people with whom she had to spend a lot of time through the holidays.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("They became less stuffy as she spoke with them and drank two cups of coffee. When she felt relaxed, they seemed warm and genuine. She was the snob.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Charles Sullivan was the new minister and his wife was with him, Joe Somebody-or-other was the assistant minister, and Bev's mother, Delores, the big-time Sunday school executive, was fluttering around like a nervous moth distributing pencils and paper for the meeting on her biggest project of the year. All things considered, Bev thought they were making a bit much of this production, but it didn't seem to be more than she could handle. It was a good thing because Carl beeped and then disappeared before they even sat down.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“We shouldn't give Carl a job,” Sharon said. “He never gets to do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“It must be hard. Do you ever see him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“We have five children. I see him when it counts. He really enjoys this kid stuff. I wish he had more time for it. Are you going to start coming here now?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“There's a little church in Murphy that's closer. I've been taking the boys there. But they want to be in the Christmas program here, so if they want to stay in this Sunday school, I'll make the long drive. Mother would be thrilled.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Well, understudy for my beloved husband, give the pageant all you've got. You may end up doing this without Carl, since so many pregnant women are shooting for tax deductions and all. Take good notes and I'll tell Carl what went on when I see him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I think I can handle it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("There wasn't much to handle. The older children would act out the Nativity and the younger ones would sing. There would be only a few lines for each class to learn and choir robes would be fashioned by loving mothers. Some decorations would be involved and Bev volunteered to do the artwork. She could have gotten off a lot easier, but she liked doing the artwork. She would be pleased to paint, and the church would be pleased to pay for the supplies.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Suddenly Beverly got excited. What did they think of the idea of a permanent backdrop for the Nativity that could be used year after year? They loved it. And what about some scene changes? Wonderful. And some stars and things to hang from the ceiling and some portable animal figures? Terrific. And how much should she spend? Oh, about fifty dollars, but they would work on getting a larger budget if necessary.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("The meeting broke up with Beverly feeling good, challenged for a change. She was wearing a not very familiar smile. It felt nice. She felt nice. Almost happy, if she dared go that far. She grabbed her coat and was going to pull it on when she noticed a man was holding it for her. It was that Joe Somebody-or-other.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Thank you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Listen, Bev, I'd be glad to help you with the artwork. You don't have much time, and I can hold a brush if you'll tell me what to do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Thanks, I might take you up on your offer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“How about taking me up on a cup of coffee? You in a hurry to get home?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“No, but...” She straightened up while preparing to knock him flat. “Aren't you married?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“No. I probably wouldn't have asked you out if I were.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("For some reason she thought preachers were issued wives in the seminary. “Well, I left the kids at Mother's. I had better pass.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“How about tomorrow night?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“For coffee?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Whatever. Can I call you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Aren't you the assistant minister here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("The assistant minister was on the make? “Doesn't that mean that you're a minister, full-fledged and anointed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Yes,” he said, and laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Then I guess that means coffee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("He shrugged. “If you say so. What's your number? Here, let me get a pencil.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Delores was waiting for her, but at quite a distance, Bev noticed. She also noticed her mother was pretending to be busy. That, Beverly knew, was so she could fool around with the assistant minister for as long as she wanted. Don't get your hopes up, Mother, she felt like calling out to Delores. He doesn't impress me.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Okay, what is it?” Joe was asking. She recited the numbers. “Good. Can you get a sitter?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“How did you know I needed one?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Aren't the kids you left at your mother's yours?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Oh, yeah. Well, how did you know I wasn't married?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Would you have accepted if you were?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Come on, Joe. Who put you up to this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“No one, honest. I've known your mother for a few months and I already guessed that you must be the widowed daughter with the two kids who moved back to Ohio.” He shrugged. “That's it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Humph, I'll bet. We aren't going to go out compliments of the collection plate, are we?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“The church pays my salary, Beverly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Then we'll go Dutch.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Beverly...”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Dutch or nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Okay, I was just going to tell you that I have an outside income. I'm a referee with the city league. Youth basketball. I could make sure I take you out on that salary.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Why do you want to take me out at all?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Why not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("He certainly didn't make it easy to refuse. Such innocence mingled with guile. Well, at least he wouldn't try to rape her, she could be reasonably sure of that. Did ministers get turned on? Doubtful. Did they drink? No. What did they do? Paint scenery for Christmas pageants, drink coffee, and save souls. Oh, Beverly! How stupid can you be? He's going to want to save your poor lost soul. How are you going to get out of this one? That was the question she was asking herself as she and Joe said good-bye.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Delores moved in then and in championship mother style extracted the news of the date from Bev. Delores quickly grew feverish with happiness. He was such a nice young man, so good-looking. He came to Ohio for this assistant's position and would very likely be getting his own church. He wasn't married, of course, but a nice man like that wouldn't be single for long. And he loved children, especially boys. Oh, and the boys were going to love him, too—")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Mother! I made a date for coffee. Now, stop it before you get so worked up you'll be a candidate for a heart attack.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“It's just what you need, Beverly, to get together with a nice man like Joe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I'm not getting together with him. I'm having coffee with him. That's all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“He has such a good outlook on life. He's been organizing sports for the young boys in the church.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Probably just another funny-bunny. “That's great, Mother. Now forget about him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Why should I forget about him? I'm glad he asked you out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“He didn't ask me 'out.' We're just going to talk about the program.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Well, that's a start—”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Mother!”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Beverly, I can't help myself. I'm happy that you're interested in a good Christian man like Joe, dark and...”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Oh, Lord, Beverly thought, her mother had no tact whatever. Getting interested in a good Christian man was not one of Bev's goals. She had been looking for a way to live without a man. She wanted to stop thinking about what to do with some man's clothes when he died, or how to scrape his image away from a home shared and loved with him. She wanted to stop wondering who would help her cut the grass, act like a father to her sons, and hold her when she cried. Looking for someone had been painful. Whether he was a Christian or a heathen wouldn't make it any easier when a man let you down... or just died. Bob had been a good Christian man.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Beverly had been a Christian.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Even now she prayed, but for something to believe in. She had decided there was no God. Or, if there was, He was indifferent and careless—and she didn't want to put her faith in one like that.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("There was a time when her faith had healed her spirit, given her hope, and added courage to her optimism. It strengthened her determination to be morally strong and decent. In raising children one couldn't just show them the world and let that guide them. She had introduced them to religion and hoped that the moral teachings of the church reinforced her efforts to help them grow into good men. She wouldn't mind if they believed there was some Divine reason for their sufferings, but she could no longer accept that.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("When she was mourning Bob's death, Delores had said, “I believe there is always a reason for these things, however hard it is to understand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Good, Mother. You believe that if you want to,” Bev had said, but she thought that no loving, caring God would kick a man when he's down.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Just the same, Beverly tried to put that minister together in her mind all the next day. She had Terry come to baby-sit and stay the night, but the eager-beaver preacher hadn't even called. Finally, at about five o'clock, he did.")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Hi, Bev. This is Joe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Hello, Joe. How are you?'")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Fine. About tonight. Let's make it seven and I'll take you to dinner. I'll treat... on my ref's salary.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I don't know, Joe. Maybe we better just stick to that coffee date.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Why? Do you have other plans?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“No, no, it's not that. Aren't your finances rather... limited?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Yes,” he admitted with a laugh. “After I have you eating out of my hand I'll just take you to the park or something on our dates.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I think I'd rather have coffee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Put on something terrific. Something feminine. I'll take you to a great place tonight and tomorrow night I'll just take you for a ride.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“I don't recall you asking me to go steady, Reverend. In fact, all I remember is that you asked me out for coffee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Okay, we're having our coffee at the Marquis Lounge. Wear something slinky. See you at seven.”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("“Joe? Joe?”")])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal3"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Well, damn. He didn't even ask how to get to her house, she fumed. Now what? And he thought she was so easy that he didn't even have to ask for a second date. Slinky? What was this slinky business? He was a minister, for Christ's sake. Well, something like that.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d17814","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Tempted05.vue
// module id = 69
// module chunks = 0